module.exports = __webpack_public_path__ + "img/niños.1ac24f81.png";